import { temperatureType } from 'store/typesActions/types';
import { api } from 'services/api';

export const getTemperatuRec = (code) => async (dispatch) => {
	dispatch({ type: temperatureType.TEMPERATURE_REC });
	try {
		const res = await api.get(`/ti/${code}/climate_temperature`);
		const { data } = res || {};
		dispatch({
			type: temperatureType.TEMPERATURE_REC_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.statsu === 400) {
			const { message } = response.data;
			dispatch({
				type: temperatureType.TEMPERATURE_REC_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: temperatureType.TEMPERATURE_REC_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
